import { CandidateFinder } from "@/pages/FindCandidate";
import { BallotWarning } from "@/components/BallotWarning";
import { BetaPreviewNotice } from "@/components/BetaPreviewNotice";

export default function DeclareEntry() {
  return (
    <CandidateFinder
      title="Witness My Vote"
      subtitle="First, find the candidate you voted for through the official election process. Your voluntary declaration takes about two minutes and produces a verifiable receipt. Witness Your Vote does not replace or cast your official ballot."
      declareMode
      extraTop={
        <div className="mt-6 max-w-3xl space-y-4">
          <BetaPreviewNotice />
          <BallotWarning testId="declare-entry-ballot-warning" />
        </div>
      }
    />
  );
}
